import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { i18next } from './lib/i18n';
import { AppRouter } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * A data router (rather than `<BrowserRouter>`) so a page can block navigation while it holds unsaved work — the
 * tracker's unsaved-changes guard (`useBlocker`). The route table itself stays declarative in `AppRouter`.
 */
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    ),
  },
]);

export const App = () => (
  <I18nextProvider i18n={i18next}>
    <QueryClientProvider client={queryClient}>
      <RouterProvider
        router={router}
        future={{ v7_startTransition: true }}
      />
    </QueryClientProvider>
  </I18nextProvider>
);
